import { useEffect, useState } from "react";
import { DatePicker, Form, Input, Select } from "antd";
import dayjs from "dayjs";
import { api } from "../common/api";
import { filterOption, fiscalCodeField, requiredField } from "../common/common";

const dateProps = {
  getValueProps: (value) => ({ value: value ? dayjs(value) : null }),
  normalize: (value) => value?.format("YYYY-MM-DD") ?? null,
};
const nameRules = [requiredField, { whitespace: true, message: "Campo obbligatorio" }];

export default function EmployeeFields() {
  const [mansions, setMansions] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let cancelled = false;
    api.mansion
      .list({ pageSize: 9999 })
      .then(({ data }) => {
        if (!cancelled) setMansions(data);
      })
      .catch(() => {
        // The API interceptor displays the error.
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);
  return (
    <>
      <Form.Item name="lastName" label="Cognome" rules={nameRules}>
        <Input />
      </Form.Item>
      <Form.Item name="firstName" label="Nome" rules={nameRules}>
        <Input />
      </Form.Item>
      <Form.Item name="fiscalCode" label="Codice fiscale" rules={[...nameRules, fiscalCodeField]}>
        <Input />
      </Form.Item>
      <Form.Item name="badgeId" label="Badge">
        <Input />
      </Form.Item>
      <Form.Item name="mansion" label="Mansione">
        <Select
          allowClear
          showSearch
          loading={loading}
          filterOption={filterOption}
          options={mansions.map((mansion) => ({ label: mansion.name, value: mansion.id }))}
        />
      </Form.Item>
      <Form.Item name="validFrom" label="Valido dal" rules={[requiredField]} {...dateProps}>
        <DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item
        name="validUntil"
        label="Valido al"
        dependencies={["validFrom"]}
        {...dateProps}
        rules={[
          ({ getFieldValue }) => ({
            validator: (_, value) =>
              !value || !getFieldValue("validFrom") || value >= getFieldValue("validFrom")
                ? Promise.resolve()
                : Promise.reject(
                    new Error("La data finale deve essere uguale o successiva a quella iniziale"),
                  ),
          }),
        ]}
      >
        <DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />
      </Form.Item>
    </>
  );
}
